import { useSites } from '../hooks/useSites';
import { APP_DOMAIN, siteLiveUrl } from '../lib/config';

export function DashboardHome() {
  const { data } = useSites();
  const site = data?.sites[0];

  if (!site) {
    return <div className="p-8">No site yet.</div>;
  }

  const liveUrl = siteLiveUrl(site.subdomain);

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-2">{site.name}</h1>
      <p className="text-gray-600 mb-6">
        Live at{' '}
        <a className="underline" href={liveUrl} target="_blank" rel="noreferrer">
          {site.subdomain}.{APP_DOMAIN}
        </a>
      </p>

      <section className="bg-white rounded shadow p-6 max-w-3xl">
        <h2 className="font-semibold mb-3">Live preview</h2>
        <iframe src={liveUrl} title="Site preview" className="w-full h-[600px] border rounded" />
      </section>
    </div>
  );
}
